// AcceptedJobsPage.jsx
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { Badge } from "../../components/ui/badge";
import { Clock, CheckCircle, XCircle, Users, Eye } from "lucide-react";
import api from "../../api/client";

export default function ApprovedJobsPage() {
 const navigate = useNavigate();
 const [jobs, setJobs] = useState([]);
 const [loading, setLoading] = useState(true);
 const [error, setError] = useState("");

 useEffect(() => {
 fetchApprovedJobs();
 }, []);

 const fetchApprovedJobs = async () => {
 try {
 const res = await api.get("/recruiter/jobs/approved");
 // IMPORTANT: backend returns { jobs: [...] }
 setJobs(res.data.jobs);
 } catch (err) {
 setError("Failed to load approved jobs");
 } finally {
 setLoading(false);
 }
 };

 const getJobStatusBadge = (status) => {
 const map = {
 PENDING: { variant: "secondary", text: "Pending Approval", icon: Clock },
 APPROVED: { variant: "default", text: "Live", icon: CheckCircle },
 REJECTED: { variant: "destructive", text: "Rejected", icon: XCircle },
 };
 const s = map[status] || map.PENDING;
 const Icon = s.icon;
 return (
 <Badge variant={s.variant} className="flex items-center gap-1 text-xs">
 <Icon className="w-3 h-3" />
 {s.text}
 </Badge>
 );
 };

 if (loading) return <p className="p-4">Loading...</p>;
 if (error) return <p className="p-4 text-red-500">{error}</p>;
 if (jobs.length === 0) return <p className="p-4">No approved jobs yet.</p>;

 return (
 <div className="p-4 space-y-4">
 {jobs.map((job) => {
 const applicants = job.applications || [];
 const pending = applicants.filter(a => a.status === "PENDING").length;
 const accepted = applicants.filter(a => a.status === "ACCEPTED").length;
 const rejected = applicants.filter(a => a.status === "REJECTED").length;

 return (
 <Card key={job.id}>
 <CardHeader className="flex justify-between items-center">
 <div>
 <h3
 className="text-lg font-semibold cursor-pointer hover:text-indigo-600"
 onClick={() => navigate(`/recruiter/jobs/${job.id}`)}
 >
 {job.title}
 </h3>
 <p className="text-sm text-muted-foreground">{job.location}</p>
 </div>
 {getJobStatusBadge(job.status)}
 </CardHeader>
 <CardContent>
 <div className="flex gap-2 mb-2">
 <Badge variant="outline" className="text-xs">
 <Clock className="w-3 h-3 mr-1" />
 {pending} Pending
 </Badge>
 <Badge variant="default" className="text-xs">
 <CheckCircle className="w-3 h-3 mr-1" />
 {accepted} Accepted
 </Badge>
 <Badge variant="destructive" className="text-xs">
 <XCircle className="w-3 h-3 mr-1" />
 {rejected} Rejected
 </Badge>
 </div>
 <div className="flex gap-2">
 <button
 onClick={() => navigate(`/recruiter/jobs/${job.id}/applicants`)}
 className="text-sm px-2 py-1 border rounded"
 >
 View Applicants
 </button>
 <button
 onClick={() => navigate(`/recruiter/jobs/${job.id}`)}
 className="text-sm px-2 py-1 border rounded"
 >
 View Job
 </button>
 </div>
 </CardContent>
 </Card>
 );
 })}
 </div>
 );
}
